import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import React, { useState } from 'react';
import { isOldServicePeriod } from './oldServicePeriod';
import { OldServicePeriodWarning } from './OldServicePeriodWarning';

/**
 * Asks before going ahead with a bill whose service period is long past (LB-6030), and goes straight ahead otherwise.
 * `confirmIfOld(periods, proceed, { confirmLabel, onCancel, title })` calls `proceed(true)` once the person confirms,
 * or `proceed(false)` at once when no period is long past; closing the dialog calls `onCancel` and nothing else.
 * Render `confirmation` once: nothing until the first time it asks.
 */
export function useOldServicePeriodConfirm() {
  // Kept as it was while the dialog closes, so its words do not change on the way out.
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    asked = _useState2[0],
    setAsked = _useState2[1];
  const confirmIfOld = function (periods, proceed) {
    let _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$confirmLabel = _ref.confirmLabel,
      confirmLabel = _ref$confirmLabel === void 0 ? 'Continue' : _ref$confirmLabel,
      onCancel = _ref.onCancel,
      title = _ref.title;
    const old = (periods || []).filter(period => isOldServicePeriod(period === null || period === void 0 ? void 0 : period.endDateOnly));
    if (!old.length) {
      proceed(false);
      return;
    }
    setAsked({
      confirmLabel,
      isOpen: true,
      onCancel,
      periods: old,
      proceed,
      title: title || 'Bill for a long-past service period?'
    });
  };

  // The dialog fades out and still takes a click meanwhile: only the click that closes an open one counts.
  const close = () => {
    var _asked$onCancel;
    if (!(asked !== null && asked !== void 0 && asked.isOpen)) return;
    setAsked(current => _objectSpread(_objectSpread({}, current), {}, {
      isOpen: false
    }));
    (_asked$onCancel = asked.onCancel) === null || _asked$onCancel === void 0 || _asked$onCancel.call(asked);
  };
  const confirm = () => {
    if (!(asked !== null && asked !== void 0 && asked.isOpen)) return;
    setAsked(current => _objectSpread(_objectSpread({}, current), {}, {
      isOpen: false
    }));
    asked.proceed(true);
  };
  const confirmation = asked ? /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: close,
    isOpen: asked.isOpen,
    leftButton: /*#__PURE__*/React.createElement(Button, {
      onClick: close,
      variant: "text"
    }, "Close"),
    rightButton: /*#__PURE__*/React.createElement(Button, {
      onClick: confirm,
      size: "small",
      variant: "contained"
    }, asked.confirmLabel),
    title: asked.title
  }, /*#__PURE__*/React.createElement(OldServicePeriodWarning, {
    periods: asked.periods
  })) : null;
  return {
    confirmation,
    confirmIfOld
  };
}